import { useState } from 'react';
import { QuoteFilter } from '../utils/FilterQuotes';
import { QuoteTagFilter } from './QuoteTagFilter';
import { P2GButton } from '@parcel2go/core-ui';
import { QuoteProductNameFilter } from './QuoteProductNameFilter';
import { P2GSidePanel } from '~/components/sidepanel';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  setTags?: (tags: string[]) => void;
  filter: QuoteFilter;
  setFilter: (f: QuoteFilter) => void;
  setMatchAllTags: (v: boolean) => void;
  productNames: { text: string; value: string }[];
  isXs: boolean;
}

const QuoteLayoutFilter: React.FC<props> = (props) => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <>
      <P2GButton variant="primary" onClick={toggle}>
        {t('FILTERS_BUTTON', { defaultValue: 'Filters' })}
      </P2GButton>
      <P2GSidePanel
        open={open}
        onClose={toggle}
        anchor="right"
        width="700px"
        title={t('FILTER_RESULTS_SIDEPANEL_TITLE', { defaultValue: 'Filter Results' })}
      >
        <QuoteTagFilter
          isXs={props.isXs}
          close={toggle}
          setTags={props.setTags}
          selected={props.filter.Tags}
          matchAllTags={props.filter.MatchAllTags}
          setMatchAllTags={props.setMatchAllTags}
        >
          <QuoteProductNameFilter
            productNames={props.productNames}
            onChange={(v) => props.setFilter({ ...props.filter, Product: v })}
            selected={props.filter.Product}
          />
        </QuoteTagFilter>
      </P2GSidePanel>
    </>
  );
};
export default QuoteLayoutFilter;
